import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const SubstantiationOngoingCoverageFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const ongoingCoverageOptions: ComboboxFilterOption<string>[] = [
    { label: 'Substantiated Premium Transaction', value: 'substantiated_premium_transaction' },
    { label: 'Manual', value: 'ongoing_coverage_manual' },
  ]
  //
  const filteredOptions = ongoingCoverageOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Ongoing Coverage', options: filteredOptions || [] }]}
        placeholder='Search ongoing coverage types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={ongoingCoverageOptions || []}
          noSelectionText='Ongoing Coverage'
          pluralIdentifier='ongoing coverage types'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SubstantiationOngoingCoverageFilter
